<template>
  <div class="certificate-query-page">
    <div class="top" v-if="isPC">
      <div></div>
      <div class="top_btn">
        <div class="btn1" @click="toBack">
          <img src="../assets/images/home.png" alt="">
          <span>返回主页</span>
        </div>
<!--        <div class="btn2" @click="toBack1">-->
<!--          <img src="../assets/images/search.png" alt="">-->
<!--          <span>继续查询</span>-->
<!--        </div>-->
      </div>
    </div>
    <div class="top1" v-if="!isPC">
      <div class="top_btn">
        <div class="btn1" @click="toBack">
          <img src="../assets/images/home.png" alt="">
          <span>返回主页</span>
        </div>
<!--        <div class="btn2" @click="toBack1">-->
<!--          <img src="../assets/images/search.png" alt="">-->
<!--          <span>继续查询</span>-->
<!--        </div>-->
      </div>
    </div>

    <!-- 主内容 -->
    <div class="main-content">

      <!-- 查询区域 -->
      <div ref="queryCard" class="query-card">
        <img class="zs" src="../assets/images/zs.png" alt="">
        <div class="form-container">
          <h1 ref="title" class="page-title">
            {{ name }}查询
          </h1>

          <div class="query-form">
            <div class="form-group">
              <div class="tit">姓 <span style="width: 1.5rem;display: inline-block"></span> 名</div>
              <el-input
                  v-model="formData.name"
                  type="text"
                  class="form-input"
              />
            </div>

            <div class="form-group">
              <div class="tit">身份证号</div>
              <el-input
                  v-model="formData.id_number"
                  type="text"
                  class="form-input"
              />
            </div>

            <!-- 证书编号 -->
            <div class="form-group">
              <div class="tit">证书编号</div>
              <el-input
                  v-model="formData.certificate_number"
                  type="text"
                  class="form-input"
              />
            </div>

            <!-- 查询按钮 -->
            <div class="submit-wrapper">
              <button type="submit" class="submit-button" @click="toSearch">点击查询</button>
            </div>
          </div>
        </div>

        <!-- 查询方式说明 -->
        <div ref="instructions" class="instructions-section">
          <h2 class="instructions-title">查询方式</h2>
          <div class="chaxun-wrap">
            <div class="instructions-grid">
              <div
                  v-for="(item, index) in queryInstructions"
                  :key="index"
                  ref="instructionItem"
                  class="instruction-item"
              >
                {{ item.key }}
              </div>
            </div>
            <div class="instructions-grid">
              <div
                  v-for="(item, index) in queryInstructions1"
                  :key="index"
                  ref="instructionItem"
                  class="instruction-item"
              >
                {{ item.key }}
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {
  search_person,
  index_config
} from "@/api/index";
export default {
  name: 'CertificateQueryPage',
  data() {
    return {
      formData: {
        name: '',
        id_number: '',
        certificate_number: '',
        type: '',
      },
      queryInstructions:[],
      queryInstructions1:[],
      isPC: false,
      name:'',
      type:'',
    };
  },
  mounted() {
    this.name = this.$route.query.name
    this.type = this.$route.query.type
    this.formData.type = this.$route.query.typeId
    this.getConfig()
    if (this.isMobile()) {
      this.isPC = false
    } else {
      this.isPC = true
    }
  },
  methods: {
    getConfig(){
      index_config().then(res => {
        if (res.code == 1) {
          this.queryInstructions = res.data.rencaiinfo.splice(0,4)
          this.queryInstructions1 = res.data.rencaiinfo
        }
      })
    },
    isMobile() {
      const ua = navigator.userAgent;
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
    },
    toBack() {
      sessionStorage.removeItem('userInfo')
      this.$router.push({
        path: '/',
        query: {}
      })
    },
    toBack1() {
      sessionStorage.removeItem('userInfo')
      this.$router.push({
        path: '/',
        query: {index: 1}
      })
    },
    handleSubmit() {
      console.log('查询数据:', this.formData);
      // 实际项目中可在此调用 API
    },
    toSearch(){
      let ajax = {
        ...this.formData
      }
      search_person(ajax).then(res => {
        console.log(res)
        if (res.code == 1) {
          if (res.data.length == 0) {
            this.$message({
              message: '暂无查询结果',
              type: 'warning'
            })
          }else{
            sessionStorage.setItem('userInfo',JSON.stringify(res.data))
            this.$router.push({
              path: '/grjg',
              query: { }
            })
          }
        }else {
          this.$message({
            message: '暂无查询结果',
            type: 'warning'
          })
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.certificate-query-page {
  width: 100%;
  position: relative;
  background-image: url("../assets/images/login_bg.png");
  background-repeat: no-repeat;
  background-size: cover;

  @media (min-width: 640px) {
    background-size: 100% 100%;
  }

  .top {
    position: absolute;
    right: 4rem;
    top: 3rem;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    .logo {
      cursor: pointer;
    }
  }

  .top1 {
    width: calc(100% - 40px);
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 20px;
    position: relative;

    img {
      width: 100%;
    }
  }

  .top_btn {
    display: flex;
    align-items: center;

    .btn1 {
      margin-left: 10px;
      cursor: pointer;
      display: flex;
      align-items: center;

      span{
        color: #FFFFFF;
      }

      img {
        width: 16px;
        height: 16px;
        margin-right: 4px;
      }
    }

    .btn2 {
      margin-left: 20px;
      cursor: pointer;
      display: flex;
      align-items: center;

      span{
        color: #FFFFFF;
      }

      img {
        width: 16px;
        height: 16px;
        margin-right: 4px;
      }
    }
  }

  .main-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    min-height: 100vh;
    padding: 1rem;
    box-sizing: border-box;
    margin-top: 0;

    @media (min-width: 640px) {
      padding: 1.5rem;
      align-items: center;
      justify-content: center;
    }
    @media (min-width: 1024px) {
      padding: 2rem;
    }

    .query-card {
      width: 100%;
      max-width: 55rem;
      border: 2px solid rgba(255, 255, 255, 0.3);
      background: rgba(30, 58, 138, 0.8); // blue-900/80
      overflow: hidden;
      transform: scale(0.95);
      border-radius: .5rem;
      margin-top: 3rem;
      position: relative;
      .zs{
        position: absolute;
        top: 0;
        right: 0;
        width: 300px;
        height: 170px;
        opacity: .3;
      }

      .form-container {
        padding: 2rem 2rem;
        @media (min-width: 640px) {
          padding: 4rem 6rem;
        }

        .page-title {
          font-size: 1.8rem;
          font-weight: 700;
          text-align: center;
          color: white;
          margin-bottom: 2.5rem;
          padding: 0 1rem;
          @media (min-width: 640px) {
            font-size: 2.5rem;
            margin-bottom: 4.5rem;
            padding: 0;
          }
        }

        .query-form {
          .form-group {
            display: flex;
            align-items: center;
            padding: .5rem 1.5rem;
            background-color: #FFFFFF;
            border-radius: 0.375rem;
            margin-bottom: 2rem;
            @media (min-width: 768px) {
              margin-bottom: 3.5rem;
            }

            .tit {
              font-size: 1.1rem;
            }

            .form-label {
              color: rgba(255, 255, 255, 0.9);
              font-weight: 500;
              font-size: 1rem;
            }

            .form-input {
              flex: 1;
              color: white;
              font-size: 1rem;
            }
          }

          .submit-wrapper {
            text-align: center;
            .submit-button {
              width: 14rem;
              padding: 1rem 1.5rem;
              background: #1e40af;
              color: white;
              font-weight: 600;
              border: 1px solid rgba(255, 255, 255, 0.2);
              border-radius: 0.35rem;
              cursor: pointer;
              transition: background-color 0.3s;
              font-size: 1rem;
              @media (min-width: 768px) {
                width: 20rem;
                font-size: 1.4rem;
              }
            }
          }
        }
      }

      .instructions-section {
        padding: 1.5rem 3rem;
        border-top: 1px solid rgba(255, 255, 255, 0.1);

        .chaxun-wrap{
          display: flex;
          flex-direction: column;
          @media (min-width: 768px) {
            flex-direction: row;
          }
        }

        .instructions-title {
          color: white;
          font-weight: 600;
          font-size: 1.2rem;
          text-transform: uppercase;
          letter-spacing: 0.1em;
          margin-bottom: 1rem;
          font-family: cursive;
        }

        .instructions-grid {
          display: flex;
          flex-direction: column;


          .instruction-item {
            color: rgba(255, 255, 255, 0.8);
            font-size: .9rem;
            margin-bottom: 1rem;
            @media (min-width: 768px) {
              &:last-child{
                margin-bottom: 0;
              }
            }
          }
        }
      }
    }

    .copyright {
      margin-top: 3rem; // mt-12
      color: rgba(255, 255, 255, 0.6);
      font-size: 0.75rem;
      text-align: center;
      @media (min-width: 640px) {
        font-size: 0.875rem;
      }
    }
  }
}

/deep/.el-input__inner{
  background: #FFFFFF !important;
  font-size: 18px;
  height: 44px;
  border: none;
  flex: 1;
  @media (min-width: 768px) {
    height: 54px;
  }
}
/deep/ input::placeholder {
  color: #333;
}
</style>
